import { DAY_LOWERCASE, DAY_TRUNCATED } from '../constants';

const mapTruncatedDayToLowercase = (day: DAY_TRUNCATED): DAY_LOWERCASE => {
  switch (day) {
    case DAY_TRUNCATED.MON:
      return DAY_LOWERCASE.MONDAY;
    case DAY_TRUNCATED.TUE:
      return DAY_LOWERCASE.TUESDAY;
    case DAY_TRUNCATED.WED:
      return DAY_LOWERCASE.WEDNESDAY;
    case DAY_TRUNCATED.THU:
      return DAY_LOWERCASE.THURSDAY;
    case DAY_TRUNCATED.FRI:
      return DAY_LOWERCASE.FRIDAY;
    case DAY_TRUNCATED.SAT:
      return DAY_LOWERCASE.SATURDAY;
    case DAY_TRUNCATED.SUN:
      return DAY_LOWERCASE.SUNDAY;
    default:
      throw new Error(`Invalid day: ${day}`);
  }
};

export default mapTruncatedDayToLowercase;
